const CupIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M6 9.5H4.5C3.83696 9.5 3.20107 9.23661 2.73223 8.76777C2.26339 8.29893 2 7.66304 2 7C2 6.33696 2.26339 5.70107 2.73223 5.23223C3.20107 4.76339 3.83696 4.5 4.5 4.5H6"
        stroke="#00CF83"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 9.5H19.5C20.163 9.5 20.7989 9.23661 21.2678 8.76777C21.7366 8.29893 22 7.66304 22 7C22 6.33696 21.7366 5.70107 21.2678 5.23223C20.7989 4.76339 20.163 4.5 19.5 4.5H18"
        stroke="#00CF83"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 22.5H20"
        stroke="#00CF83"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 15.1599V17.4999C10 18.0499 9.53 18.4799 9.03 18.7099C7.85 19.2499 7 20.7399 7 22.4999"
        stroke="#00CF83"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 15.1599V17.4999C14 18.0499 14.47 18.4799 14.97 18.7099C16.15 19.2499 17 20.7399 17 22.4999"
        stroke="#00CF83"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 2.5H6V9.5C6 11.0913 6.63214 12.6174 7.75736 13.7426C8.88258 14.8679 10.4087 15.5 12 15.5C13.5913 15.5 15.1174 14.8679 16.2426 13.7426C17.3679 12.6174 18 11.0913 18 9.5V2.5Z"
        stroke="#00CF83"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CupIcon
